import { render, staticRenderFns } from "./ItemDropdownImage.vue?vue&type=template&id=f27546ce"
import script from "./ItemDropdownImage.vue?vue&type=script&lang=js"
export * from "./ItemDropdownImage.vue?vue&type=script&lang=js"
import style0 from "./ItemDropdownImage.vue?vue&type=style&index=0&id=f27546ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports